import { useSyncExternalStore } from "react";

/**
 * Below a window wide enough to hold a column beside the screen, the desktop
 * arrangement has nowhere to stand and the phone one takes over. `shell.css`
 * changes sides at the same width, and so does every other surface in the app
 * that has two arrangements.
 */
const PHONE_WIDTH = "(width < 40rem)";

const query = () => window.matchMedia(PHONE_WIDTH);

function subscribe(notify: () => void) {
  const phone = query();
  phone.addEventListener("change", notify);
  return () => phone.removeEventListener("change", notify);
}

/**
 * Only for the things CSS cannot say: down here the ways are not an
 * arrangement to be in, they are a list that opens and shuts, so the mark
 * carries a different icon, a different label and a different press.
 */
export function usePhoneWidth() {
  return useSyncExternalStore(
    subscribe,
    () => query().matches,
    () => false,
  );
}
